import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import zhHans from 'vuetify/src/locale/zh-Hans';
import 'typeface-roboto/index.css';
import '@mdi/font/css/materialdesignicons.css';
Vue.use(Vuetify);
export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#25323E',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#de5353',
        info: '#5895f0',
        success: '#edf5ea',
        warning: '#e28b21'
      }
    }
  },
  lang: {
    locales: {
      zhHans: zhHans
    },
    current: 'zhHans'
  },
  icons: {
    iconfont: 'mdi'
  }
});